<template lang="pug">
  DataTablePage(
    resource="log/operation"
    title="操作日志"
    label="日志"
    labelName="userId"
    :tableFullList="tableFullList"
    :tableInitList="tableInitList"
    :filterFullList="filterFullList"
    :filterInitList="filterInitList"
    :columns="columns")
</template>

<script>
import DataTablePage from '@/containers/DataTablePage'
import { expire } from '@/utils/auth'

export default {
  name: 'log',
  components: {
    DataTablePage
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  data () {
    return {
      tableInitList: ['userId', 'loginName', 'moduleId', 'controllerId', 'actionId', 'actionPath', 'desc', 'success', 'logTime'],
      tableFullList: ['userId', 'loginName', 'moduleId', 'controllerId', 'actionId', 'actionPath', 'desc', 'success', 'logTime'],
      filterInitList: ['userId', 'moduleId', 'success'],
      filterFullList: ['userId', 'moduleId', 'success'],
      columns: {
        userId: {
          label: '操作用户',
          width: 120,
          type: 'select',
          relation: 'users',
          filter: {
            type: 'select',
            live: true
          }
        },
        loginName: {
          label: '操作账号',
          width: 120
        },
        clientIp: {
          label: '操作用户IP',
          width: 120
        },
        moduleId: {
          label: '模块',
          width: 140,
          type: 'select',
          relation: 'menus',
          filter: {
            type: 'select'
          }
        },
        controllerId: {
          label: '功能',
          width: 120,
          type: 'select',
          relation: 'controllers',
          filter: {
            type: 'select',
            width: 100
          }
        },
        actionId: {
          label: '功能点',
          width: 120,
          type: 'select',
          relation: 'actions',
          filter: {
            type: 'select',
            width: 100
          }
        },
        actionPath: {
          label: '功能点路径'
        },
        desc: {
          label: '说明'
        },
        success: {
          label: '是否成功',
          width: 98,
          type: 'select',
          relation: 'yesOrNo',
          filter: {
            type: 'select',
            width: 100
          }
        },
        logTime: {
          label: '操作时间',
          type: 'time',
          dateType: 'YYYY-MM-DD HH:mm:ss'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Log.vue?50220e26